import { memo, useEffect } from 'react';

import { connect } from 'react-redux';

import { showToast, hideToast } from '../../../redux/actions/toast';

const OFFLINE_MSG = 'You are offline. Please check your internet connection.';

const OfflineObserver = memo((props) => {
  useEffect(() => {
    window.addEventListener('offline', () => {
      props.showToast('error', OFFLINE_MSG, 9999999);
    });
    window.addEventListener('online', () => {
      props.hideToast();
    });

    return () => {
      window.removeEventListener('offline', () => {});
      window.removeEventListener('online', () => {});
    };
  }, []);

  return null;
});

OfflineObserver.displayName = 'OfflineObserver';

export default connect(null, { showToast, hideToast })(OfflineObserver);
